import userReducer from '../stores/user/user.store';
import menusReducer from '../stores/menus/menus.store';
import tagsViewReducer from './tagView/tag-view.store';
import permissiomsReducer from '../stores/permissions/permissions.store';
import systemReducer from '../stores/system/system.store';
const rootReducer = {
  user: userReducer,
  menus: menusReducer,
  tagsView: tagsViewReducer,
  permissions: permissiomsReducer,
  system: systemReducer
};

export default rootReducer;
